module.exports = __webpack_public_path__ + "img/17_103.dd1a2343.png";